import React from "react";
import { Navigate } from "react-router-dom";
import { RequireRole } from "../../app/router/RequireRole";
import { AcademyLayout } from "./components/AcademyLayout";
import { SedesPage } from "./pages/SedesPage";
import { AulasPage } from "./pages/AulasPage";
import { PaquetesPage } from "./pages/PaquetesPage";
import { PoliticasPage } from "./pages/PoliticasPage";
import { TarifasPage } from "./pages/TarifasPage";
import { DocentesPage } from "./pages/DocentesPage";
import { PropietariosPage } from "./pages/PropietariosPage";
import { TemasPage } from "./pages/TemasPage";
import { NivelesPage } from "./pages/NivelesPage";
import { EstudiantesPage } from "./pages/EstudiantesPage";
import { ClasesAdminPage } from "./pages/ClasesAdminPage";

/**
 * Academy feature routes — TASK-09 (R6: owned exclusively by src/features/academy/).
 *
 * All routes live under /:slug/app/academia/ and are gated to role=OWNER.
 * AcademyLayout wraps children with the react-hot-toast Toaster.
 *
 * /:slug/app/academia/sedes      → SedesPage    (Headquarters CRUD)
 * /:slug/app/academia/paquetes   → PaquetesPage (HourPackage CRUD)
 * /:slug/app/academia/politicas  → PoliticasPage (AcademyPolicy singleton)
 * /:slug/app/academia/tarifas    → TarifasPage  (TeacherRate CRUD + history)
 *
 * Extension points:
 *   TASK-16 → honorarios/liquidación live in src/features/billing/ (not here).
 *   TASK-18 → plan/superadmin UI in src/features/superadmin/ (not here).
 */
const academyRoutes = [
  {
    path: "/:slug/app/academia",
    element: (
      <RequireRole roles={["OWNER"]}>
        <AcademyLayout />
      </RequireRole>
    ),
    children: [
      // Landing on /academia → redirect to the first config section.
      { index: true, element: <Navigate to="sedes" replace /> },
      { path: "sedes", element: <SedesPage /> },
      { path: "aulas", element: <AulasPage /> },
      { path: "paquetes", element: <PaquetesPage /> },
      { path: "politicas", element: <PoliticasPage /> },
      { path: "tarifas", element: <TarifasPage /> },
      { path: "clases", element: <ClasesAdminPage /> },
      { path: "docentes", element: <DocentesPage /> },
      { path: "propietarios", element: <PropietariosPage /> },
      { path: "estudiantes", element: <EstudiantesPage /> },
      { path: "temas", element: <TemasPage /> },
      { path: "niveles", element: <NivelesPage /> },
    ],
  },
];

export default academyRoutes;
